import { Form, Button, Checkbox, Spin, Typography, Space } from "antd"
import React, {useState} from "react"
import PropTypes from "prop-types"

import { LATEST_TERMS_OF_SERVICE_VERSION } from "@components/Domain/Constants"

const { Item } = Form
const { Title } = Typography

const backstageUpdateTermsOperation = "backstage/AcceptTermsOfService"
const investorUpdateTermsOperation = "investments/AcceptTermsOfService"

const LABEL_CONTENT = "By checking this box you agree to our Terms of Service [include hyperlink] and Privacy Policy [include hyperlink], as well as our partner Dwolla’s Terms of Service [include hyperlink] and Privacy Policy [include hyperlink]."
const LABEL_SUBMIT = "Agree and Continue"
const LABEL_TITLE = "Terms Of Service"

const TermsOfService = ({identityId, isBackstage, request, afterAccepted}) => {
  const [ form ] = Form.useForm()
  const [isLoading, setIsLoading] = useState(false)

  const operation = isBackstage ? backstageUpdateTermsOperation : investorUpdateTermsOperation

  const acceptedTermsVersionValue = Form.useWatch("_acceptedTermsVersion", form)

  const isButtonDisabled = !acceptedTermsVersionValue

  const onFinish = ({_acceptedTermsVersion}) => {
    if (_acceptedTermsVersion) {
      setIsLoading(true)

      const mutation = {
        acceptedTermsVersion: LATEST_TERMS_OF_SERVICE_VERSION
      }

      request(operation, { id: identityId, mutation })
        .then(() => afterAccepted())
        .then(() => setIsLoading(false))
    }
  }

  return (
    <Spin
      spinning={isLoading}
    >
      <div  style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}>
        <Space
          direction="vertical"
          style={{
            marginTop: "10vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            maxWidth: 600
          }}
        >
          <Title
            level={3}
            style={{textAlign: "center"}}
          >
            {LABEL_TITLE}
          </Title>

          <Form
            form={form}
            name="basic"
            onFinish={onFinish}
          >
            <Item
              name="_acceptedTermsVersion"
              valuePropName="checked"
            >
              <Checkbox>
                {LABEL_CONTENT}
              </Checkbox>
            </Item>

            <Item style={{
              display: "flex",
              justifyContent: "center"
            }}>
              <Button
                size="large"
                disabled={isButtonDisabled}
                htmlType="submit"
              >
                {LABEL_SUBMIT}
              </Button>
            </Item>
          </Form>
        </Space>
      </div>
    </Spin>
  )
}

TermsOfService.propTypes = {
  identityId: PropTypes.string.isRequired,
  request: PropTypes.func.isRequired,
  isBackstage: PropTypes.bool.isRequired,
  afterAccepted: PropTypes.func.isRequired,
}

export default TermsOfService
